import { useEffect } from 'react';

export function useWorkaroundBodyBackground(color: string) {
	useEffect(() => {
		document.getElementsByTagName('body')[0].style.setProperty('background-color', color);
	}, [color]);
}
